'use client';

import { cn } from '@module/lib/utils';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { type ReactNode, useCallback } from 'react';

interface Props {
  children: ReactNode;
  path: string;
  className?: string;
}

function SearchRouteTab({ children, path, className }: Props) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();

  const isCurrentTab = pathname === path;

  const handleClick = useCallback(() => {
    router.push(`${path}?${new URLSearchParams(searchParams).toString()}`);
  }, [path, searchParams]);

  return (
    <button
      type='button'
      className={cn(
        'mr-10 pb-4',
        {
          'border-t-4 border-t-transparent border-b-4 border-b-borderBg04': isCurrentTab,
        },
        className,
      )}
      onClick={handleClick}
    >
      <p
        className={cn('mx-1 whitespace-nowrap text-colorFg01', {
          'font-bold': isCurrentTab,
        })}
      >
        {children}
      </p>
    </button>
  );
}

export default SearchRouteTab;
